import React from "react";
import {useNavigate} from "react-router-dom";
import {Button, Icon, IconProps, Text} from "atmosfair-ui"
import './styles.css'
import {theme} from "../../styles/theme";
import {PATH_STRINGS} from "../../routes/route-props";
import TopButtonsWrapper from "../../components/button-groups/top-buttons-wrapper/TopButtonsWrapper";
import LoadBundlesButton from "../../container/buttons/load-bundles-button/LoadBundlesButton";
import {BundleType} from "../../container/buttons/common";
import {useTranslation} from "react-i18next";

interface ButtonProps {
    path: string;
    icon: IconProps["icon"];
    translationKey: string;
}

const Home = () => {
    const navigate = useNavigate()
    const {t} = useTranslation()

    const _renderButton = ({path, icon, translationKey}: ButtonProps) => (
        <Button
            onClick={() => navigate(path)}
            containerClasses={"home-option-button"}>
            <Icon size={"small"} color={theme.colors.white} icon={icon}/>
            {/*Cannot use variant "headlineMedium" because of ARIA*/}
            <Text
                toUpperCase={true}
                classes={"home-button-text"}
                color={"white"}
                variant={"body"}>
                {t(translationKey)}
            </Text>
        </Button>
    )

    return <>
        <TopButtonsWrapper rightButtons={
            <>
                <LoadBundlesButton
                    showBundleIcon={true}
                    whatToLoad={BundleType.travelComponents}/>
                <LoadBundlesButton
                    showBundleIcon={true}
                    whatToLoad={BundleType.journey}/>
            </>
        }/>
        <section className={"home-container"}>
            {_renderButton({
                path: PATH_STRINGS.newJourney,
                icon: "suitcase",
                translationKey: "SCREENS.CREATE_JOURNEY.SITE_TITLE"
            })}
            {_renderButton({
                path: PATH_STRINGS.selectTravelComponents,
                icon: "shapes",
                translationKey: "SCREENS.SELECT_TRAVEL_COMPONENTS.SITE_TITLE"
            })}
        </section>
    </>
}

export default Home